import { SignalRHubHelper } from "../ajax";
import store, { AppActionTypes } from "../store";
import { AppMutationTypes } from "../store/mutations";

export function configureSignalR(): void {
    // Create a client and project hub connection to update the client/project items when they're changed:
    const clientHubConnection =
        SignalRHubHelper.createConnection("/hub/ClientHub");
    const projectHubConnection =
        SignalRHubHelper.createConnection("/hub/ProjectHub");

    // Reset the client items upon a client being updated (ex: someone else just updated a client's name):
    clientHubConnection.on("ClientUpdated", () => {
        store.commit(AppMutationTypes.setClientItems, []);
        store.dispatch(AppActionTypes.getClientItems);
    });

    // Reset the project items upon a project being updated (ex: someone else just updated a projects's name):
    projectHubConnection.on("ProjectUpdated", () => {
        store.commit(AppMutationTypes.setProjectItems, {});
        store.dispatch(AppActionTypes.getProjectItems);
    });

    clientHubConnection.start();
    projectHubConnection.start();
}
